import { App } from './App';
import { installJustifyWords } from './text/justifyWords';

const canvas = document.querySelector<HTMLCanvasElement>('#scene');
if (!canvas) {
  throw new Error('canvas#scene not found');
}

const app = new App(canvas);
app.start();

installJustifyWords();
